const VALID_CALLBACK_DOMAINS = [
  'nubestaging.com',
  'nubestaging.com.br',
  'tiendanube.com',
  'mitiendanube.com',
  'nuvemshop.com.br',
  'lojavirtualnuvem.com.br',
];

export default function isValidCallbackDomain(domain: string) {
  return VALID_CALLBACK_DOMAINS.some(
    (validDomain) =>
      domain === validDomain || domain.endsWith(`.${validDomain}`),
  );
}
